import { Button, VStack, Text } from '@chakra-ui/react';
import React, { ReactElement } from 'react';
import { SharedModalProps } from 'types/Modal';
import { useLogout } from 'utils/auth';
import { useSentry } from 'hooks/useSentry';
import * as braze from '@braze/web-sdk';
import { isBrazeInitialized } from 'consent/initBraze';
import { CustomModal } from '../CustomModal';
import { CustomModalContent } from '../CustomModalContent';

type Props = SharedModalProps;

export const LogoutModal = ({ handleClose, isShown }: Props): ReactElement => {
  const logout = useLogout();
  const { clearUser: clearSentryUser } = useSentry();

  const handleLogout = (): void => {
    logout.mutate({});
    clearSentryUser();
    if (isBrazeInitialized()) {
      braze.wipeData();
    }
    handleClose();
  };
  return (
    <CustomModal isOpen={isShown} onClose={handleClose} placement="center" hideHeader size="sm">
      <CustomModalContent p="12px 20px">
        <VStack textAlign="center">
          <Text textStyle="body.m.regular" my="5">
            Bist du sicher, dass du dich aus deinem Account ausloggen möchtest?
          </Text>

          <Button onClick={handleLogout} variant="primary" w="full">
            Ausloggen
          </Button>
          <Button onClick={handleClose} variant="tertiary" color="text.accent">
            Abbrechen
          </Button>
        </VStack>
      </CustomModalContent>
    </CustomModal>
  );
};
